import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const CarSeatFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M14.8439 19.5673H6.16592C5.07745 15.4808 3.13192 16.2382 14.0962 17.3679C13.9438 12.3991 14.4636 13.5427 17.3413 9.57772L14.8439 19.5673ZM19.7068 2.2373H17.8085C17.2864 2.2373 16.8593 2.66447 16.8593 3.18652V6.03402H19.7068V2.2373ZM19.7072 6.99969H16.8596C14.9531 11.199 12.4262 10.992 12.4262 15.5032C12.4262 15.5032 7.77039 14.9888 6.41924 14.823C4.85468 14.5725 3.53776 15.3404 3.64586 16.8843C3.69663 17.6097 4.95153 21.1967 4.99082 21.2373H16.1478L19.7072 6.99969Z" />
      <path d="M14.8439 19.5673H6.16592C5.07745 15.4808 3.13192 16.2382 14.0962 17.3679C13.9438 12.3991 14.4636 13.5427 17.3413 9.57772L14.8439 19.5673Z" />
    </SvgIcon>
  );
});
